export default function initMainNav() {
  const nav = document.querySelector(".nav--main");
  if (!nav) return;

  const menus = [];

  nav.querySelectorAll(".nav__list > .menu-item-has-children").forEach((item, index) => {
    const link = item.querySelector(":scope > a");
    const submenu = item.querySelector(":scope > .sub-menu");
    if (!link || !submenu) return;

    const isButton = link.getAttribute("href") === "#";
    const state = { hovered: item.matches(":hover"), expanded: false, dismissed: false };

    const isOpen = () => state.expanded || (state.hovered && !state.dismissed);

    const render = () => {
      const open = isOpen();
      item.classList.toggle("is-open", open);
      link.setAttribute("aria-expanded", String(open));
    };

    const close = () => {
      if (submenu.contains(document.activeElement)) link.focus();
      state.expanded = false;
      state.dismissed = state.hovered;
      render();
    };

    submenu.id = "main-submenu-" + index;
    if (isButton) link.setAttribute("role", "button");
    link.setAttribute("aria-controls", submenu.id);
    render();

    item.addEventListener("mouseenter", () => {
      state.hovered = true;
      render();
    });
    item.addEventListener("mouseleave", () => {
      state.hovered = false;
      state.dismissed = false;
      render();
    });
    item.addEventListener("focusin", (e) => {
      if (!isButton || submenu.contains(e.target)) {
        state.expanded = true;
        render();
      }
    });
    item.addEventListener("focusout", (e) => {
      if (item.contains(e.relatedTarget)) return;
      state.expanded = false;
      render();
    });

    if (isButton) {
      const toggle = () => {
        if (isOpen()) {
          close();
          return;
        }
        state.expanded = true;
        state.dismissed = false;
        link.focus();
        render();
      };

      link.addEventListener("click", (e) => {
        e.preventDefault();
        if (e.detail === 0) toggle();
      });
      link.addEventListener("keydown", (e) => {
        if (e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });
    }

    menus.push({ isOpen, close });
  });

  nav.classList.add("is-ready");

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    menus.filter((menu) => menu.isOpen()).forEach((menu) => menu.close());
  });
}
